import React, { ChangeEventHandler } from 'react'
import styled from '@emotion/styled'
import { isMobileOnly } from 'react-device-detect'
import Select from 'src/videocall/components/Select'
import { css } from '@emotion/core'

const SettingContainer = styled.label`
  width: 100%;
  margin-bottom: 26px;

  @media screen and (max-width: 1200px) {
    margin-bottom: 20px;
  }

  @media screen and (max-width: 900px) {
    margin-bottom: 12px;
  }
`

const SettingLabel = styled.div`
  color: #737991;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 14px;

  @media screen and (max-width: 1200px) {
    font-size: 12px;
    line-height: 18px;
  }

  @media screen and (max-width: 900px) {
    font-size: 10px;
    line-height: 12px;
  }

  ${isMobileOnly &&
  css`
    font-size: 16px !important;
    line-height: 24px !important;
  `}
`

const SettingContent = styled.div<{ isCompact: boolean }>`
  display: ${({ isCompact }) => (isCompact ? 'flex' : 'block')};
  justify-content: space-between;
`

const MobileSettingContainer = styled.div`
  margin-bottom: 20px;
  width: 100%;

  @media (orientation: landscape) {
    max-width: 35vw;
  }
`

const MobileSettingLabel = styled(SettingLabel)`
  color: #737991;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  margin-bottom: 9px;
`

interface ISettingsItem extends React.HTMLProps<HTMLDivElement> {
  isCompact: boolean
  items?: any[]
  label: string
  value?: string
  onValueChange?: ChangeEventHandler<HTMLSelectElement>
}

export default function Setting({
  children,
  isCompact,
  items,
  label,
  value,
  onValueChange,
}: ISettingsItem) {
  const getDeviceLabel = (device) => {
    return device.label || device.name || device.deviceId.substring(0, 10)
  }
  return (
    <>
      {!isMobileOnly && (
        <SettingContainer>
          <SettingLabel>{label}</SettingLabel>
          <SettingContent isCompact={isCompact}>
            {items && (
              <Select onChange={onValueChange} value={value}>
                {items.map((it) => (
                  <option key={it.deviceId || it.name} value={it.deviceId || it.name}>
                    {it.label || it.name}
                  </option>
                ))}
              </Select>
            )}
            {children}
          </SettingContent>
        </SettingContainer>
      )}
      {isMobileOnly && (
        <MobileSettingContainer>
          <MobileSettingLabel>{label}</MobileSettingLabel>
          <SettingContent isCompact={isCompact}>
            {items && (
              <Select onChange={onValueChange} value={value}>
                {items.map((it) => (
                  <option key={it.deviceId || it.name} value={it.deviceId || it.name}>
                    {getDeviceLabel(it)}
                  </option>
                ))}
              </Select>
            )}
            {children}
          </SettingContent>
        </MobileSettingContainer>
      )}
    </>
  )
}

Setting.defaultProps = {
  items: null,
  onValueChange: () => {},
  value: '',
}
